import { create } from 'zustand'

const FAVORITES_STORAGE_KEY = 'xenon-flex-pool-favorites'

function loadFavorites(): string[] {
  try {
    const stored = localStorage.getItem(FAVORITES_STORAGE_KEY)
    return stored ? JSON.parse(stored) : []
  } catch (error) {
    console.error('[PoolStore] Failed to load favorites:', error)
    return []
  }
}

function saveFavorites(favorites: string[]): void {
  try {
    localStorage.setItem(FAVORITES_STORAGE_KEY, JSON.stringify(favorites))
  } catch (error) {
    console.error('[PoolStore] Failed to save favorites:', error)
  }
}

interface PoolState {
  favorites: string[]
  toggleFavorite: (poolID: string) => void
  isFavorite: (poolID: string) => boolean
}

export const usePoolStore = create<PoolState>((set, get) => ({
  favorites: loadFavorites(),

  toggleFavorite: (poolID: string) => {
    const { favorites } = get()
    const newFavorites = favorites.includes(poolID)
      ? favorites.filter((id) => id !== poolID)
      : [...favorites, poolID]

    saveFavorites(newFavorites)
    set({ favorites: newFavorites })
  },

  isFavorite: (poolID: string) => {
    return get().favorites.includes(poolID)
  },
}))
